import { useState } from 'react'
import { Alert, AlertDescription, AlertIcon, Box, Flex, Spinner, Stack, Switch, Tooltip } from '@chakra-ui/react'

import { FormItem } from 'components'
import { useCustomFormBuilder } from '../../contexts/CustomFormBuilderManagerContext/Provider'

export default function CustomFormBuilderIsProtected() {
  const [loadingSwitch, setLoadingSwitch] = useState<boolean>(false)

  const { canUpdateFormVisibility, updateFormVisibility, permissions, form, setForm } = useCustomFormBuilder()

  async function changeFormVisibility(isProtected: boolean) {
    setLoadingSwitch(true)
    const response = await updateFormVisibility({ is_protected: isProtected })
    if (response?.header?.success) {
      setForm({ ...form, is_protected: isProtected })
    }
    setLoadingSwitch(false)
  }

  if (!canUpdateFormVisibility) {
    return null
  }

  if (form?.is_restricted) {
    return (
      <Stack>
        <Alert status="error" rounded="md">
          <AlertIcon />
          <AlertDescription>Este formulário é restrito, não poderá ser atualizado e deletado.</AlertDescription>
        </Alert>
        <Tooltip label="Este formulário é restrito, não pode ser alterado / deletado.">
          <Box width="max-content">
            <FormItem label="Este formulário é protegido?" helperText="">
              <Switch size="md" isDisabled={form?.is_restricted} checked={form?.is_protected} />
            </FormItem>
          </Box>
        </Tooltip>
      </Stack>
    )
  }

  return (
    <Stack>
      <Alert status="info" rounded="md">
        <AlertIcon />
        <AlertDescription>Um formulário protegido não poderá ser atualizado e deletado.</AlertDescription>
      </Alert>
      <Tooltip isDisabled={permissions?.updateFormVisibility} label="Você não tem permissão.">
        <Box width="max-content">
          <FormItem label="Este formulário é protegido?" helperText="">
            <Flex align="center" gap={4}>
              <Switch
                size="md"
                isDisabled={loadingSwitch || !permissions?.updateFormVisibility}
                isChecked={form?.is_protected}
                onChange={({ target }) => changeFormVisibility(target.checked)}
              />

              {loadingSwitch && <Spinner thickness="3px" />}
            </Flex>
          </FormItem>
        </Box>
      </Tooltip>
    </Stack>
  )
}
